export const forYouItems: string[] = [
  'Insegni motoria, educazione fisica o scienze motorie',
  'Non hai tempo per programmare ogni settimana',
  'Vuoi lezioni pronte ma serie, non esercizi trovati a caso',
  'Hai bisogno di griglie e descrittori per il registro',
]

export const notForYouItems: string[] = [
  'Cerchi un corso di formazione con attestato',
  'Vuoi schede personalizzate per un singolo alunno',
  'Non hai intenzione di stampare o proiettare nulla',
]
